import * as yup from "yup";
import { ReferenceField } from "../interfaces";
import { getNonPermanentJobTypes, JobType } from "./job";

export const TerminationReason = {
    abandonedJob: "Abandoned Job",
    attendance: "Attendance",
    completedAssignment: "Completed Assignment",
    performance: "Performance",
    layoff: "Layoff",
    mutualAgreement: "Mutual Agreement",
    misconduct: "Misconduct - Policy Violation",
    personalReasons: "Personal Reasons",
    voluntaryResignation: "Voluntary Resignation",
    shiftChange: "Shift Change",
    titleChange: "Title Change",
    placedInError: "Placed in Error",
    neverStarted: "Never Started",
};

export const getTerminationReasonChoices = () => {
    const choices = Object.values(TerminationReason).map((o) => ({
        label: o,
        value: o,
    }));
    choices.unshift({ label: "", value: "" });
    return choices;
};

export const TerminationReasonChoices: ReferenceField[] =
    getTerminationReasonChoices();

export const placementFormSchema = yup.object({
    candidateId: yup.string().required("Candidate ID is required"),
    startDate: yup.string().required("Start date is required"),
    guaranteeDate: yup.string().nullable(),
    payRate: yup.number().when("type", {
        is: getNonPermanentJobTypes(),
        then: yup.number().required("Pay rate is required"),
        otherwise: yup.number().nullable(),
    }),
    billRate: yup.number().when("job.type", {
        is: getNonPermanentJobTypes(),
        then: yup.number().required("Bill rate is required"),
        otherwise: yup.number().nullable(),
    }),
    otPayRate: yup.number().when("job.type", {
        is: getNonPermanentJobTypes(),
        then: yup.number().required("OT pay rate is required"),
        otherwise: yup.number().nullable(),
    }),
    otBillRate: yup.number().when("job.type", {
        is: getNonPermanentJobTypes(),
        then: yup.number().required("OT bill rate is required"),
        otherwise: yup.number().nullable(),
    }),
    dtPayRate: yup.number().when("job.type", {
        is: getNonPermanentJobTypes(),
        then: yup.number().required("OT pay rate is required"),
        otherwise: yup.number().nullable(),
    }),
    dtBillRate: yup.number().when("job.type", {
        is: getNonPermanentJobTypes(),
        then: yup.number().required("OT bill rate is required"),
        otherwise: yup.number().nullable(),
    }),
    directFee: yup.number().when("job.type", {
        is: JobType.permanent,
        then: yup.number().required("Direct fee is required"),
        otherwise: yup.number().nullable(),
    }),
    assignedUserId: yup.string().required("Assigned user is required"),
});
